var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_15501)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.03125,
    width: 38.0569,
    height: 38,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.03125,
    width: 38.0569,
    height: 38,
    rx: 8,
    fill: "#F79421",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2247 17.457C18.2013 17.3398 18.2364 17.2344 18.3302 17.1406C18.4239 17.0469 18.5294 17 18.6466 17H20.545C20.6388 17 20.7091 17.0234 20.756 17.0703C20.8263 17.0938 20.8731 17.1406 20.8966 17.2109C20.9435 17.2812 20.9669 17.3633 20.9669 17.457L20.756 21.3945C20.7325 21.4883 20.6739 21.582 20.5802 21.6758C20.5099 21.7461 20.4278 21.7812 20.3341 21.7812H18.8575C18.5997 21.7812 18.4591 21.6523 18.4356 21.3945L18.2247 17.457ZM20.6153 22.7305C20.92 23.0117 21.0724 23.3516 21.0724 23.75C21.0724 24.1484 20.92 24.5 20.6153 24.8047C20.3341 25.0859 19.9942 25.2266 19.5958 25.2266C19.1974 25.2266 18.8458 25.0859 18.5411 24.8047C18.2599 24.5 18.1192 24.1484 18.1192 23.75C18.1192 23.3516 18.2599 23.0117 18.5411 22.7305C18.8458 22.4258 19.1974 22.2734 19.5958 22.2734C19.9942 22.2734 20.3341 22.4258 20.6153 22.7305ZM21.0724 11.0938L29.5099 25.7188C29.8145 26.2812 29.8028 26.8438 29.4747 27.4062C29.17 27.9688 28.6895 28.25 28.0333 28.25H11.1583C10.502 28.25 10.0099 27.9688 9.68173 27.4062C9.37705 26.8438 9.37705 26.2812 9.68173 25.7188L18.1192 11.0938C18.4474 10.5312 18.9395 10.25 19.5958 10.25C20.252 10.25 20.7442 10.5312 21.0724 11.0938ZM11.3341 26.2461C11.2169 26.457 11.2755 26.5625 11.5099 26.5625H27.6817C27.752 26.5625 27.8106 26.5273 27.8575 26.457C27.9044 26.3867 27.9044 26.3164 27.8575 26.2461L19.7716 12.2539C19.7247 12.1836 19.6661 12.1484 19.5958 12.1484C19.5255 12.1484 19.4669 12.1836 19.42 12.2539L11.3341 26.2461Z",
    fill: "#EFA00B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_15501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.0569,
    height: 38,
    fill: "white",
    transform: "translate(0.03125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3b384f70d4d8e2c4bfce2d9ad69b55c0.svg";
export { ForwardRef as ReactComponent };